// CANONICAL COPY (GH #7115). src/constants/obligations/obl-ip-rights.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-ip-rights',
  title: 'Verify intellectual property rights and supported software',
  description:
    'Confirm that procedures protect intellectual property rights for software, documentation and data, including licensing compliance and the removal or replacement of software that is no longer supported by the vendor. Unsupported software that cannot be removed shall be documented with compensating controls and a remediation plan.',
  category: 'compliance',
  scfIds: ['SCF-GOV-010'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'Intellectual property / software supportability policy is published',
    },
    { type: 'document-within-sla', description: 'Policy review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
